/* ==========================================================================
   AuroraWave — interactividad propia (sin librerias)
   Una funcion init por componente; cada una comprueba si su elemento existe.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Reveals al hacer scroll (un solo observer compartido) --------------- */
  function initReveals() {
    var items = document.querySelectorAll('.aw-reveal');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('aw-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Visible en pantalla, o ya lo hemos dejado atras (scroll rapido)
        if (entry.isIntersecting || entry.boundingClientRect.bottom < 0) {
          entry.target.classList.add('aw-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    items.forEach(function (el) { observer.observe(el); });

    // Red de seguridad: nada que haya quedado por encima del viewport se queda oculto
    var pendiente = false;
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () {
        pendiente = false;
        items.forEach(function (el) {
          if (!el.classList.contains('aw-visible') && el.getBoundingClientRect().bottom < 0) {
            el.classList.add('aw-visible');
            observer.unobserve(el);
          }
        });
      });
    }, { passive: true });
  }

  /* --- Parallax suave del fondo del hero ----------------------------------- */
  function initHeroParallax() {
    var heroes = document.querySelectorAll('.aw-hero[data-parallax]');
    if (!heroes.length || reduceMotion) return;

    var ticking = false;
    function update() {
      heroes.forEach(function (hero) {
        var img = hero.querySelector('.aw-hero__fondo img');
        if (!img) return;
        var factor = parseFloat(hero.getAttribute('data-parallax')) || 0;
        var rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var offset = -rect.top * factor;
        img.style.transform = 'scale(1.06) translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* --- Selector de 16 colores ---------------------------------------------- */
  function initColores() {
    var secciones = document.querySelectorAll('.aw-colores');
    if (!secciones.length) return;

    secciones.forEach(function (sec) {
      var escena = sec.querySelector('.aw-colores__escena');
      var muestras = sec.querySelectorAll('.aw-muestra');
      var etiqueta = sec.querySelector('[data-color-nombre]');
      var etiquetaEscena = sec.querySelector('[data-color-nombre-escena]');
      if (!escena || !muestras.length) return;

      function activar(btn) {
        muestras.forEach(function (m) { m.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        escena.style.setProperty('--aw-tinte', btn.getAttribute('data-color'));
        var nombre = btn.getAttribute('data-nombre') || '';
        if (etiqueta) etiqueta.textContent = nombre;
        if (etiquetaEscena) etiquetaEscena.textContent = nombre;
      }

      muestras.forEach(function (btn) {
        btn.addEventListener('click', function () { activar(btn); });
      });

      activar(muestras[0]);

      // Auto-rotacion suave hasta que el usuario toca una muestra
      var auto = sec.getAttribute('data-auto') === 'true' && !reduceMotion;
      if (auto) {
        var i = 0;
        var timer = setInterval(function () {
          i = (i + 1) % muestras.length;
          activar(muestras[i]);
        }, 1800);
        sec.addEventListener('click', function () { clearInterval(timer); }, { once: true });
      }
    });
  }

  /* --- FAQ acordeon --------------------------------------------------------- */
  function initFaq() {
    var botones = document.querySelectorAll('.aw-faq__boton');
    if (!botones.length) return;

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.aw-faq__item');
        var abierto = item.classList.contains('is-abierto');
        var lista = item.parentElement;
        lista.querySelectorAll('.aw-faq__item.is-abierto').forEach(function (o) {
          o.classList.remove('is-abierto');
          var b = o.querySelector('.aw-faq__boton');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!abierto) {
          item.classList.add('is-abierto');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* --- Galeria de producto -------------------------------------------------- */
  function initGaleria() {
    var galerias = document.querySelectorAll('.aw-galeria');
    if (!galerias.length) return;

    galerias.forEach(function (g) {
      var principal = g.querySelector('.aw-galeria__principal img');
      var minis = g.querySelectorAll('.aw-mini');
      if (!principal || !minis.length) return;

      function mostrar(mini) {
        minis.forEach(function (m) { m.setAttribute('aria-current', 'false'); });
        mini.setAttribute('aria-current', 'true');
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = mini.getAttribute('data-src');
          principal.srcset = mini.getAttribute('data-srcset') || '';
          principal.alt = mini.getAttribute('data-alt') || '';
          principal.style.opacity = '1';
        }, 160);
        // Mantiene la miniatura activa a la vista (en movil son una tira deslizable)
        if (mini.scrollIntoView) {
          try { mini.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) { /* navegadores antiguos */ }
        }
      }

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () { mostrar(mini); });
      });

      // Deslizar con el dedo sobre la foto grande: siguiente / anterior
      var contenedor = g.querySelector('.aw-galeria__principal');
      var x0 = null, y0 = null;
      contenedor.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      contenedor.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        x0 = y0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var lista = Array.prototype.slice.call(minis);
        var actual = lista.findIndex(function (m) { return m.getAttribute('aria-current') === 'true'; });
        var siguiente = dx < 0 ? actual + 1 : actual - 1;
        if (siguiente < 0) siguiente = lista.length - 1;
        if (siguiente >= lista.length) siguiente = 0;
        mostrar(lista[siguiente]);
      }, { passive: true });
    });
  }

  /* --- Barra de compra fija en movil ---------------------------------------- */
  function initBarraCompra() {
    var barras = document.querySelectorAll('[data-barra-compra]');
    if (!barras.length) return;

    barras.forEach(function (barra) {
      if (barra.getAttribute('data-listo') === 'true') return;
      barra.setAttribute('data-listo', 'true');
      var seccion = barra.closest('.shopify-section') || document;
      var botonPrincipal = seccion.querySelector('[data-boton-compra]');
      var botonBarra = barra.querySelector('[data-barra-boton]');
      if (!botonPrincipal || !botonBarra) return;

      document.body.classList.add('aw-con-barra');

      function mostrar(si) {
        if (si) {
          barra.hidden = false;
          barra.setAttribute('aria-hidden', 'false');
          // El siguiente frame, para que la transicion se vea
          window.requestAnimationFrame(function () { barra.classList.add('is-visible'); });
        } else {
          barra.classList.remove('is-visible');
          barra.setAttribute('aria-hidden', 'true');
          barra.hidden = true;
        }
      }

      // Se muestra cuando el boton principal ha quedado por encima de la pantalla
      function comprobar() {
        var r = botonPrincipal.getBoundingClientRect();
        mostrar(r.bottom < 0);
      }
      var pendiente = false;
      window.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        window.requestAnimationFrame(function () { pendiente = false; comprobar(); });
      }, { passive: true });
      comprobar();

      // El boton de la barra dispara el boton real (asi el carrito se abre igual)
      botonBarra.addEventListener('click', function () {
        if (botonPrincipal.disabled) return;
        botonPrincipal.click();
      });
    });
  }

  /* --- Variantes de producto ----------------------------------------------- */
  function initVariantes() {
    var forms = document.querySelectorAll('.aw-compra[data-variantes]');
    if (!forms.length) return;

    forms.forEach(function (wrap) {
      var dataEl = wrap.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var inputId = wrap.querySelector('input[name="id"]');
      var precioEl = wrap.querySelector('[data-precio]');
      var tachadoEl = wrap.querySelector('[data-precio-tachado]');
      var ahorroEl = wrap.querySelector('[data-ahorro]');
      var boton = wrap.querySelector('[data-boton-compra]');
      var botonTexto = boton ? (boton.querySelector('[data-boton-texto]') || boton) : null;
      var textoDisponible = boton ? boton.getAttribute('data-texto-disponible') : '';
      var textoAgotado = boton ? boton.getAttribute('data-texto-agotado') : '';
      // Solo los grupos de opciones reales (el selector de cantidad tambien usa .aw-opcion)
      var grupos = Array.prototype.filter.call(wrap.querySelectorAll('.aw-opcion'), function (g) {
        return g.querySelector('.aw-opcion__valor');
      });
      var moneda = wrap.getAttribute('data-moneda') || '{{amount}}';
      // La barra de compra fija (movil) vive fuera de la columna de compra
      var seccion = wrap.closest('.shopify-section') || document;
      var barraPrecio = seccion.querySelector('[data-barra-precio]');
      var barraTachado = seccion.querySelector('[data-barra-tachado]');
      var barraBoton = seccion.querySelector('[data-barra-boton]');

      // Formatea centimos segun el formato de moneda de la tienda
      function formatear(centimos) {
        var m = moneda.match(/\{\{\s*(amount[a-z_]*)\s*\}\}/);
        var tipo = m ? m[1] : 'amount';
        var valor;
        if (tipo.indexOf('no_decimals') !== -1) {
          valor = String(Math.round(centimos / 100));
        } else {
          valor = (centimos / 100).toFixed(2);
        }
        if (tipo.indexOf('comma_separator') !== -1) {
          valor = valor.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        } else if (tipo.indexOf('apostrophe') !== -1) {
          valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        } else {
          valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return m ? moneda.replace(m[0], valor) : valor;
      }

      function seleccionActual() {
        var sel = [];
        grupos.forEach(function (grupo) {
          var activo = grupo.querySelector('.aw-opcion__valor[aria-pressed="true"]');
          sel.push(activo ? activo.getAttribute('data-valor') : null);
        });
        return sel;
      }

      function actualizar() {
        var sel = seleccionActual();
        var v = null;
        if (grupos.length) {
          v = variantes.find(function (variante) {
            return variante.options.every(function (o, i) { return o === sel[i]; });
          });
        }
        // Sin opciones que elegir (variante unica o valores ocultos): usa la primera variante
        if (!v && (!grupos.length || variantes.length === 1)) {
          v = variantes.find(function (variante) { return variante.available; }) || variantes[0];
        }
        if (!v) {
          if (boton) { boton.disabled = true; botonTexto.textContent = textoAgotado; }
          if (barraBoton) barraBoton.disabled = true;
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precioEl) precioEl.textContent = formatear(v.price);
        if (barraPrecio) barraPrecio.textContent = formatear(v.price);
        if (barraTachado) {
          var hayTachado = v.compare_at_price && v.compare_at_price > v.price;
          barraTachado.textContent = hayTachado ? formatear(v.compare_at_price) : '';
          barraTachado.hidden = !hayTachado;
        }
        if (barraBoton) barraBoton.disabled = !v.available;
        if (tachadoEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            tachadoEl.textContent = formatear(v.compare_at_price);
            tachadoEl.hidden = false;
            if (ahorroEl) {
              var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
              ahorroEl.textContent = '-' + pct + '%';
              ahorroEl.hidden = false;
            }
          } else {
            tachadoEl.hidden = true;
            if (ahorroEl) ahorroEl.hidden = true;
          }
        }
        if (boton) {
          boton.disabled = !v.available;
          botonTexto.textContent = v.available ? textoDisponible : textoAgotado;
        }
      }

      grupos.forEach(function (grupo) {
        grupo.querySelectorAll('.aw-opcion__valor').forEach(function (btn) {
          btn.addEventListener('click', function () {
            grupo.querySelectorAll('.aw-opcion__valor').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
            btn.setAttribute('aria-pressed', 'true');
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  /* --- Cifras animadas (count-up) ------------------------------------------ */
  function initContadores() {
    var nums = document.querySelectorAll('[data-contador]');
    if (!nums.length) return;

    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-contador')) || 0;
      var sufijo = el.getAttribute('data-sufijo') || '';
      var decimales = (String(fin).split('.')[1] || '').length;
      if (reduceMotion) { el.textContent = fin.toFixed(decimales) + sufijo; return; }
      var inicio = null;
      var dur = 1400;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var p = Math.min((ts - inicio) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (fin * eased).toFixed(decimales) + sufijo;
        if (p < 1) window.requestAnimationFrame(paso);
      }
      window.requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) { nums.forEach(animar); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { obs.observe(n); });
  }

  /* --- Videos de ambiente: reproducir solo cuando estan en pantalla ------- */
  function initVideos() {
    var videos = document.querySelectorAll('.aw-hero__video, .aw-hero__fondo video, .aw-video__marco video');
    if (!videos.length || reduceMotion) return;

    function reproducir(v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) { videos.forEach(reproducir); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) reproducir(e.target);
        else e.target.pause();
      });
    }, { threshold: 0.1 });
    videos.forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      obs.observe(v);
    });

    // Si el navegador bloqueo la reproduccion automatica, reintenta al primer toque
    document.addEventListener('touchstart', function () { videos.forEach(function (v) { if (v.paused) reproducir(v); }); }, { once: true, passive: true });
  }

  /* --- Cupón: copiar el código al tocar --------------------------------- */
  function initCupon() {
    var cupones = document.querySelectorAll('.aw-cupon[data-cupon]');
    if (!cupones.length) return;
    cupones.forEach(function (btn) {
      var estado = btn.querySelector('[data-cupon-estado]');
      var original = estado ? estado.textContent : '';
      btn.addEventListener('click', function () {
        var codigo = btn.getAttribute('data-cupon');
        var listo = function () {
          btn.classList.add('is-copiado');
          if (estado) estado.textContent = 'Copiado ✓';
          setTimeout(function () { btn.classList.remove('is-copiado'); if (estado) estado.textContent = original; }, 2500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(listo, listo);
        } else {
          listo();
        }
      });
    });
  }

  function init() {
    initReveals();
    initVideos();
    initCupon();
    initHeroParallax();
    initColores();
    initFaq();
    initGaleria();
    initVariantes();
    initBarraCompra();
    initContadores();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de Shopify recarga secciones sin recargar la pagina
  document.addEventListener('shopify:section:load', init);
})();
